import type React from "react"

interface AssessmentHeaderProps {
  showResults: boolean
  currentQuestion?: number
  totalQuestions?: number
}

export const AssessmentHeader: React.FC<AssessmentHeaderProps> = ({ showResults, currentQuestion, totalQuestions }) => {
  return (
    <div className="text-center mb-8">
      <div className="inline-block bg-indigo-100 text-indigo-700 px-6 py-2 rounded-full mb-4 text-sm font-semibold border border-indigo-200">
        {showResults ? "Career Results" : "Career Explorer Quiz"}
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-3">
        {showResults ? "Your Career Matches!" : "Discover Your Future!"}
      </h1>
      <p className="text-lg text-slate-600 max-w-2xl mx-auto">
        {showResults
          ? "Here are your personalized career matches based on your answers!"
          : "Let's find the perfect career that matches your amazing personality!"}
      </p>
    </div>
  )
}
